import React, {useState} from 'react';
import Dropzone from 'react-dropzone';
import firebase from '../firebase';

const storage = firebase.storage();

interface ImageUploaderProps {
  className: string;
  filePath: string;
  message: string;
}

const ImageUploader = ({className, filePath, message}: ImageUploaderProps) => {
  const [imageUrl, setImageUrl] = useState<string>(null as unknown as string);
  storage
    .ref(filePath)
    .getDownloadURL()
    .then((response) => {
      setImageUrl(response);
    })
    .catch((err) => {
      // Didn't exist... or some other error
    });

  const onFilesDrop = (files: File[]) => {
    if (files && files.length >= 1) {
      return storage.ref().child(filePath)
        .put(files[0])
        .then(result => result.ref.getDownloadURL().then(response => setImageUrl(response)));
    }
  };

  return (
    <div>
      <Dropzone onDrop={onFilesDrop}>
        {({getRootProps, getInputProps}) => (
          <div>
          {
              <div {...getRootProps()}>
                <input {...getInputProps()} />
                {imageUrl?
                  <img style={{height: '100%', width: '100%'}} src={imageUrl} alt="uploaded"/> :
                  <div style={{width: 120, padding: 'auto', border: '1px solid rgb(216, 216, 216)', lineHeight: "120px", cursor: 'pointer'}}>
                    {message}
                  </div>}
              </div>

          }
          </div>
        )}
      </Dropzone>

    </div>
  );
};

export default ImageUploader;